import { render, staticRenderFns } from "./TopClassWebsite.vue?vue&type=template&id=4ce33a94&scoped=true"
import script from "./TopClassWebsite.vue?vue&type=script&lang=js"
export * from "./TopClassWebsite.vue?vue&type=script&lang=js"
import style0 from "./TopClassWebsite.vue?vue&type=style&index=0&id=4ce33a94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce33a94",
  null
  
)

export default component.exports